// lista wybranych kategorii - stabilna wersja z poziomym scrollem
// @ts-nocheck

import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { Trans } from 'react-i18next';
import classnames from 'classnames';
import { ArrowLeft, ArrowRight } from 'react-bootstrap-icons';

import { Link } from 'components/controls';
import { useGetHomeCategories } from 'api';

import styles from 'theme/pages/Home/components/SelectedCategories/SelectedCategories.module.scss';

export const SelectedCategories: FC = () => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const [canGoLeft, setCanGoLeft] = useState(false);
  const [canGoRight, setCanGoRight] = useState(false);
  const { data: homeCategoriesData } = useGetHomeCategories();
  const categories = homeCategoriesData?.items || [];

  const syncNavState = useCallback(() => {
    const el = carouselRef.current;
    if (!el) return;

    const maxScrollLeft = Math.max(0, el.scrollWidth - el.clientWidth);
    setCanGoLeft(el.scrollLeft > 1);
    setCanGoRight(el.scrollLeft < maxScrollLeft - 1);
  }, []);

  useEffect(() => {
    const el = carouselRef.current;
    if (!el) return;

    syncNavState();
    el.addEventListener('scroll', syncNavState, { passive: true });
    window.addEventListener('resize', syncNavState);

    return () => {
      el.removeEventListener('scroll', syncNavState);
      window.removeEventListener('resize', syncNavState);
    };
  }, [syncNavState, categories.length]);

  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -272, behavior: 'smooth' });
      window.setTimeout(syncNavState, 250);
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: 272, behavior: 'smooth' });
      window.setTimeout(syncNavState, 250);
    }
  };

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Pages-Home-components-SelectedCategories'
      )}>
      <div className={styles.headerWithNav}>
        <h2 className={styles.title}>
          <Trans>Sprawdź</Trans>
        </h2>
        <div className={styles.navigation}>
          <button
            className={classnames(
              styles.navButton,
              styles.back,
              canGoLeft ? styles.active : styles.inactive
            )}
            onClick={scrollLeft}
            aria-label="Poprzednie">
            <ArrowLeft />
          </button>
          <button
            className={classnames(
              styles.navButton,
              styles.next,
              canGoRight ? styles.active : styles.inactive
            )}
            onClick={scrollRight}
            aria-label="Następne">
            <ArrowRight />
          </button>
        </div>
      </div>

      <div className={styles.categoryWrapper} ref={carouselRef}>
        {categories.map((category) => {
          const target = category?.url_link?.trim?.() || `/products?category_id=${category.id}`;
          const content = (
            <div className={styles.imageContainer}>
              <img className={styles.img} src={category.image} alt={category.name} />
              <div className={styles.gradient}></div>
              <div className={styles.name}>{category.name}</div>
            </div>
          );
          return /^https?:\/\//i.test(target) ? (
            <a className={styles.item} key={category.id} href={target}>
              {content}
            </a>
          ) : (
            <Link className={styles.item} key={category.id} to={target}>
              {content}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default SelectedCategories;
